<template>
  <div class="page">
    <div class="app-container">
      <el-button type="primary" @click="add">新增</el-button>
      <BaseTable
        ref="baseTable"
        url="/admin/special/index"
        :tableData.sync="tableData"
        :columns="columns"
      >
        <template #handle="{ row }">
          <el-button type="text" size="mini" @click="edit(row)">编辑</el-button>
          <el-button type="text" size="mini" @click="del(row)">删除</el-button>
        </template>
      </BaseTable>

      <el-drawer
        title="编辑特别约定"
        :visible.sync="isShowDrawer"
        direction="rtl"
        @close="drawerClose"
      >
        <div style="padding: 40px">
          <el-form :model="formData" labelWidth="100px" size="medium">
            <el-form-item label="特约名称">
              <el-input v-model="formData.tyName" required></el-input>
            </el-form-item>
            <el-form-item label="特约内容">
              <el-input
                type="textarea"
                v-model="formData.tyContent"
                rows="4"
                required
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">保存</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import { columns } from "./columns";
import { searchFormOption } from "./formOptions";
export default {
  name: "Agreement",
  comments: {},
  data() {
    return {
      tableData: [],
      isShowDrawer: false,
      formData: {},
      searchData: {},
      isEdit: false,
    };
  },
  computed: {
    columns,
    searchFormOption,
  },
  created() {},
  methods: {
    // 点击搜索
    handleSearch() {
      console.log(this.searchData);
      this.$refs.baseTable.searchData();
    },
    add() {
      this.formData = {};
      this.isShowDrawer = true;
    },

    async edit(row) {
      this.isEdit = true;
      this.isShowDrawer = true;
      this.formData = {
        ...row,
      };
    },

    del({ id }) {
      this.$confirm("是否确认删除该约定模版, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.$api.post("/admin/special/del", { id }, "删除");
          this.handleSearch();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },

    async onSubmit() {
      let url = "";
      let msg = "";
      if (this.isEdit) {
        url = "/admin/special/edit";
        msg = "添加";
      } else {
        url = "/admin/special/add";
        msg = "删除";
      }
      await this.$api.post(url, this.formData, msg);
      this.isShowDrawer = false;
      this.handleSearch();
    },

    // 抽屉关闭
    drawerClose() {
      this.formData = {};
    },
  },
};
</script>
